import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HeaderVue from './components/Header.vue';
import animateScrollTo from 'animated-scroll-to';
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
import FooterVue from './components/Footer.vue';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
watch(() => route.params.index, (index) => {
  handleChange(Number(index))
})
/**
 * 检测要跳转到的页面部分
 */
const activeIndex = ref(0);
const tempHeight = ref();
const handleChange = (swiper: any) => {
  activeIndex.value = swiper
  animateScrollTo(tempHeight.value * activeIndex.value)
}

const handleHeightChange = (height: number) => {

  tempHeight.value = height;
  //animateScrollTo(tempHeight.value * activeIndex.value)
  setTimeout(() => {
    animateScrollTo(tempHeight.value * activeIndex.value)
  })
}

const handleWheelChange = (isDown: boolean) => {
  return
  if (!isDown && activeIndex.value === 0) return;
  if (isDown && activeIndex.value === 6) return;
  if (isDown) {
    //向下
    setTimeout(() => {
      handleChange(Number(activeIndex.value) + 1)
    })
  } else {
    setTimeout(() => {
      handleChange(Number(activeIndex.value) - 1)
    })
  }
}



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderVue, {
      activeIndex: activeIndex.value,
      onTrigger: handleChange
    }, null, 8, ["activeIndex"]),
    _createVNode(_component_router_view, {
      activeIndex: activeIndex.value,
      onHeightChange: handleHeightChange,
      onWheelChange: handleWheelChange,
      onIndexChange: handleChange
    }, null, 8, ["activeIndex"])
  ], 64))
}
}

})